import { Component, Input, OnInit } from '@angular/core';
import { NumberSpacingPipe } from '../../../../../shared/pipes/number-spacing.pipe';

@Component({
  selector: 'app-collect-invoice-confirmation',
  templateUrl: './collect-invoice-confirmation.component.html',
  styleUrls: ['./collect-invoice-confirmation.component.scss'],
  providers: [NumberSpacingPipe],
})
export class CollectInvoiceConfirmationComponent implements OnInit {
  @Input() entity: any;

  readonly placeholder = '--';

  invoice: any = {};
  feeData: any = {};
  paymentDate: string;
  actualPaymentDate: string;
  invoicingConfiguration: string;
  isFeeApplied = false;
  newRefundAmount: any;
  showFeeAjuste = false;

  currency = 'pen';
  currencySymbol = '';
  empresaPagadora = this.placeholder;
  empresaGiradora = this.placeholder;
  facturas = this.placeholder;
  invoicingConfigurationLabel = this.placeholder;

  private readonly invoicingLabels: { [key: string]: string } = {
    normal: 'Factura al girador: Girador asume todo el pago (Se consume la garantía)',
    debtorAll: 'Facturación partida: Girador asume solo lo pactado',
    debtorExtra: 'Facturación partida: Girador asume hasta agotar garantía',
    noInvoicing: 'No facturar automáticamente',
    delay: '--',
  };

  constructor(private numberSpacing: NumberSpacingPipe) {}

  ngOnInit(): void {
    this.invoice = this.entity?.invoice || {};
    this.feeData = this.entity?.feeData || {};
    this.paymentDate = this.entity?.paymentDate;
    this.actualPaymentDate = this.entity?.actualPaymentDate;
    this.invoicingConfiguration = this.entity?.invoicingConfiguration;
    this.isFeeApplied = !!this.entity?.isFeeApplied;
    this.newRefundAmount = this.entity?.newRefundAmount;
    this.showFeeAjuste = !!this.entity?.showFeeAjuste;

    this.currency = this.invoice?.currency || 'pen';
    this.currencySymbol =
      this.invoice?.currencySymbol || (this.currency === 'pen' ? 'S/ ' : '$ ');

    this.empresaPagadora = this.invoice?.debtor?.companyName
      ? this.invoice.debtor.companyName.toUpperCase()
      : this.placeholder;

    const giradora = this.invoice?.isConfirming
      ? this.invoice?.supplier?.companyName
      : this.invoice?.issuer?.companyName;
    this.empresaGiradora = giradora ? giradora.toUpperCase() : this.placeholder;

    const codes = (this.invoice?.physicalInvoices || [])
      .map((physicalInvoice: any) => physicalInvoice?.code)
      .filter((code: string) => !!code);
    this.facturas = codes.length ? codes?.join(', ')?.toUpperCase() : this.placeholder;

    this.invoicingConfigurationLabel =
      this.invoicingLabels[this.invoicingConfiguration] ||
      this.invoicingConfiguration ||
      this.placeholder;
  }

  private hasValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  money(value: any): string {
    if (!this.hasValue(value)) {
      return this.placeholder;
    }
    return this.currencySymbol + this.numberSpacing.transform(value);
  }

  get garantia(): string {
    return this.money(this.invoice?.reservationAmount);
  }

  get tcemLabel(): string {
    return this.invoice?.isConfirming
      ? 'Costo mensual de Confirming'
      : 'Costo mensual de factoring';
  }

  get tcem(): string {
    return this.hasValue(this.feeData?.tcem)
      ? `${this.feeData.tcem}%`
      : this.placeholder;
  }

  get interesesMoratorios(): string {
    const lateFee = Number(this.feeData?.lateFee);
    if (
      !this.isFeeApplied ||
      !this.hasValue(this.feeData?.lateFee) ||
      isNaN(lateFee) ||
      lateFee <= 0
    ) {
      return this.placeholder;
    }
    return this.money(this.feeData.lateFee);
  }

  get feeAjuste(): string {
    if (
      this.invoice?.commissionAdjustment &&
      this.invoice.commissionAdjustment !== '0.00'
    ) {
      return '---';
    }
    return this.money(this.feeData?.adjustmentFee);
  }

  get costoSinIgv(): string {
    return this.money(this.feeData?.costWithoutIGV);
  }

  get comisionFinsmartLabel(): string {
    return (
      'Comisión Finsmart' +
      (this.invoice?.commissionAdjustment ? ' (Ajuste de comisión Finsmart)' : '')
    );
  }

  get comisionFinsmart(): string {
    if (!this.hasValue(this.feeData?.finsmartReturn)) {
      return this.placeholder;
    }
    return (
      this.currencySymbol +
      this.numberSpacing.transform(this.feeData.finsmartReturn) +
      (this.invoice?.commissionAdjustment
        ? ` (${this.feeData?.commissionAdjustment})`
        : '')
    );
  }

  get costoFinanciamiento(): string {
    return this.money(this.feeData?.investorReturn);
  }

  get igv(): string {
    return this.money(this.feeData?.finsmartReturnIGV);
  }

  get precioTotal(): string {
    return this.money(this.feeData?.newTotalReturn);
  }

  get devolucion(): string {
    return this.money(this.newRefundAmount);
  }
}
